import * as Yup from "yup";
export const formikAddUser = {
    initialValues: {
        firstName: "",
        lastName: "",
        dob: "",
        roles: [],
        email : "",
        primaryPhone : "",
        secondaryPhone : "",
        jobTitle: "",
        address : "",
        city: "",
        state: "",
        postalCode: "",
        country: "",
        employer:"",
        department: "",
        defaultLogInOrg : null,
        orgId: null,
        defaultLogInClinic: null,
        hospitalAccess: [],
        defaultRoleId: ""

    }
};

export const formikEditUser = {
    initialValues: {
        firstName: "",
        lastName: "",
        dob: "",
        // roles: [],
        email : "",
        primaryPhone : "",
        secondaryPhone : "",
        jobTitle: "",
        address : "",
        city: "",
        state: "",
        postalCode: "",
        country: "",
        employer:"",
        department: "",
        orgId: "",
        // hospitalAccess: [],
        defaultRoleId: ""

    },
    validationSchema: Yup.object({
        firstName: Yup.string().required("Required Field"),
        lastName: Yup.string().required("Required Field"),
        // roles: Yup.array().required("Required Field"),
        email: Yup.string().email("Invalid Email Format").required("Required Field"),
        primaryPhone: Yup.string().required("Required Field"),
        jobTitle: Yup.string().required("Required Field"),
        // secondaryPhone: Yup.string().required("Required Field"),
        // address: Yup.string().required("Required Field"),
        city: Yup.string().required("Required Field"),
        state: Yup.string().required("Required Field"),
        postalCode: Yup.string().required("Required Field"),
        country: Yup.string().required("Required Field"),
        employer: Yup.string().required("Required Field"),
        department: Yup.string().required("Required Field")
        // dob: Yup.string().required("Required Field")
    })
};


export const formikAddOrgAccess = {
    initialValues: {
        defaultLogInClinic: "",
        orgId: "",
        existingUserId: "",
        hospitalAccess: []
    },
    validationSchema: Yup.object({
        defaultLogInClinic: Yup.string().required("Required Field"),
        orgId: Yup.string().required("Required Field"),
        hospitalAccess: Yup.array().required("Required Field")
    })
};

export const formikAddRoleAccess = {
    initialValues: {
        roles: [],
        userId: ""
    },
    validationSchema: Yup.object({
        roles: Yup.array().required("Required Field")
    })
};

export const formikAddRole = {
    initialValues: {
        roleName : "",
        portalLayout : "",
        roleId : "",
        description : ""
    },
    validationSchema: Yup.object({
        roleName: Yup.string().required("Required Field"),
        portalLayout: Yup.string().required("Required Field")
    })
};

export const roleOptions = [
    { value: 'SuperAdmin', label: 'Platform Admin' },
    { value: 'SuperAdmin-Staff', label: 'Platform Admin Staff' },
    { value: 'OrgAdmin', label: 'Orgnization Admin' },
    { value: 'ClinicAdmin', label: 'Clinic Admin' },
    { value : 'ClinicAdmin-Staff' , label: 'Clinic Admin Staff'}
];

export const portalLayoutOption = [
    { value: 'Platform', label: 'Platform' },
    { value: 'Organization', label: 'Organization' }
    // { value: 'Patient', label: 'Patient' }
];

export const genderOptions = [
    { value: 'male', label: 'Male' },
    { value: 'female', label: 'Female' },
    { value: 'other', label: 'Other' }
];

export const permissionNames = [
    { value: 'read', label: 'Read' },
    { value: 'create', label: 'Create' },
    { value: 'edit', label: 'Edit' },
    { value: 'delete', label: 'Delete' }
];
